import { gql } from '@apollo/client';

export interface UserNavProgarm {
  id: string;
  name: string;
  seasons: Array<UserNavSeason>;
}

export interface UserNavSeason {
  id: string;
  name: string;
  fullName: string;
  tsDivisionId: string;
  coordinatedDivisions: Array<UserNavCoordinatedDivision>;
}

export interface UserNavCoordinatedDivision {
  id: string;
  name: string;
}

export interface UserNavOrganization {
  id: string;
  name: string;
  programs: Array<UserNavProgarm>;
}

export interface Data {
  organizations: Array<UserNavOrganization>;
}

export const QUERY = gql`
  query UserNavigation {
    userNavigation {
      organizations {
        id
        name
        websiteUrl
        tournamentOrgId
        isOrgV2
        programs {
          id
          name
          seasons {
            id
            name
            tsDivisionId
            coordinatedDivisions {
              id
              name
            }
          }
        }
      }
    }
  }
`;
